module.exports = __webpack_public_path__ + "img/PORT15.6059ff9f.jpg";